import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../authentication/AuthProvider";
import { enums } from "../enums/Enums";
import { findCurrectPermission } from "../helpers/roles-and-permissions";
import { routes } from "../routes/routes";

export function TimeandAttendanceLunchGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.T_A_IN_OUT_FOR_LUNCH) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function TimeandAttendanceBusinessGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.T_A_IN_OUT_FOR_BUSINESS) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function TimeandAttendancePersonalBusinessGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.T_A_IN_OUT_FOR_PERSONAL_BUSINESS
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function TimeandAttendanceMissingPunchesGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.T_A_MY_MISSING_PUNCHES) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function TimeandAttendanceMyTimePunchesGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function TimeandAttendanceBuildingGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.T_A_WHO_IS_IN_THE_BUILDING
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}
